import { render, staticRenderFns } from "./add-contact-details.vue?vue&type=template&id=01620739&scoped=true"
import script from "./add-contact-details.vue?vue&type=script&lang=js"
export * from "./add-contact-details.vue?vue&type=script&lang=js"
import style0 from "./add-contact-details.vue?vue&type=style&index=0&id=01620739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01620739",
  null
  
)

export default component.exports